// extracted by mini-css-extract-plugin
module.exports = {"blink_dot":"StreamingText_blink_dot__2-1-T","blink":"StreamingText_blink__biYGe"};